<template>
	<span>
		<sf-data-table
			:pageUnit="pagingInfo.pageUnit"
			:totalSize="pagingInfo.totalSize"
			:currentPage="pagingInfo.currentPage"
			paging
			excel
			:columns="columns"
			ref="resultList"
			:rows="resultList"
			@changedPage="changedPage"
		/>
	</span>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/LibraryDependency/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return { screen: {} };
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {},
	computed: {
		...serviceComputed,
		...rootComputed,
		columns() {
			return [
				{
					// label: this.getMessage_('SWCC000742'),
					label: this.getMessage_('SWCC000360'),
					prop: 'rnum',
					minWidth: '40px'
				},
				{
					label: this.getMessage_('SWCC000397'),
					prop: 'devLang',
					minWidth: '60px'
				},
				{
					label: this.getMessage_('SWCC000768'),
					prop: 'branch',
					minWidth: '60px'
				},
				{
					label: this.getMessage_('SWCC000250'),
					prop: 'serviceName',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('SWCC000775'),
					prop: 'serviceNamespace',
					minWidth: '140px'
				},
				{
					label: this.getMessage_('SWCC000769'),
					prop: 'serviceDesc',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000770'),
					prop: 'libraryName',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('SWCC000330'),
					prop: 'ver',
					minWidth: '60px'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		reloadData() {
			this.$emit('Refresh');
		},
		saveClick() {
			const selectedRows = this.$refs.resultList.getSelectedRows();
			if (selectedRows.length < 1) {
				// title 선택한 정보가 없습니다.\
				// message 저장 할 데이터를 선택해 주세요.
				this.$showMessage({ title: this.getMessage_('SWCC000417'), message: this.getMessage_('SWCC000434') });
				return;
			}

			this.$showMessage({
				type: 'confirm',
				message: this.getMessage_('SWCC000555'), // 저장하시겠습니까?
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		},
		save() {
			let sendData = {
				status: 1,
				plantCd: this.plant,
				data: []
			};
			const payload = this.$refs.resultList.getSelectedRows();

			this.$toggleLoading(true);
			this.setConfirm({ plantCd: this.plant, payload })
				.then(data => {
					if (data.header.code === 200) {
						this.$toast({
							icon: 'ok',
							title: data.header.message,
							position: 'bottom-right',
							message: data.header.message
						});
						this.reloadData();
					}
				})
				.catch(error => {
					this.$toast({
						type: 'error',
						message: error.message ? error.message : error
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$toggleLoading(false);
				});
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>
